import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enUsTrans from "./en-us.json";
import zhCnTrans from "./zh-cn.json";
import viVnTrans from "./vi-vn.json";

export const LANG_STORAGE_KEY = "admin-language";
export type AppLanguage = "zh" | "en" | "vn";

export const languageLabelMap: Record<AppLanguage, string> = {
  en: "English",
  zh: "Chinese",
  vn: "Vietnam",
};

const savedLanguage = (localStorage.getItem(LANG_STORAGE_KEY) || "en") as AppLanguage;

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: enUsTrans },
    zh: { translation: zhCnTrans },
    vn: { translation: viVnTrans },
  },
  lng: ["zh", "en", "vn"].includes(savedLanguage) ? savedLanguage : "en",
  fallbackLng: "en",
  debug: false,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
